
import { AloPositionRemarquable, IAloPositionRemarquableConstParam } from '@/models/alo/AloPositionRemarquable';
import { FilterBase } from '@/models/filter/FilterBase';

export interface IPositionRemarquableState {
    status:string
    positionRemarquables: Array<AloPositionRemarquable>
    modifiedAdmPositionRemarquable: AloPositionRemarquable
    originalAdmPositionRemarquable: AloPositionRemarquable
    positionRemarquableLoading: boolean
    adminFilter: FilterBase
}
  
const state:IPositionRemarquableState = { 
    status: '',
    positionRemarquables: [],
    modifiedAdmPositionRemarquable: new AloPositionRemarquable(),
    originalAdmPositionRemarquable: new AloPositionRemarquable(),
    positionRemarquableLoading:false,
    adminFilter: new FilterBase()
}
  
export default state